import styled from "styled-components"

export const HorizontalRule = styled.div`
  background-color: var(--bg-light-2);
  height: 2px;
`
